// extracted by mini-css-extract-plugin
module.exports = {"title":"PostForm_title__3Uzxq","label":"PostForm_label__2-wtk","submit":"PostForm_submit__L66by","preview":"PostForm_preview__2wCsz"};